import React from 'react';
import Grid from '@material-ui/core/Grid';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { withStyles } from '@material-ui/core/styles';

import RouteHeader from '../RouteHeader/routeHeader';
import Card from '../../../Helper/CardWrapper/cardWrapper'
import ErrorComponent from '../../../Helper/ErrorComponent/errorComponent';
import ContentGrid from '../../../Helper/gridWrapper/gridWrapper';
import {GetDeal,GetPotential} from '../../../Actions/dealActions';
import MyDealForm from './dealForm';
import DealsAppView from './dealsAppView';
import DealSearch from './dealSearch';

const styles={

};

class Deals extends React.Component {
    constructor(props){
        super(props);
        this.state={
            open:true,
          dealData:{},
          myDeals:{},
          user:{},
          flag:false,
          showErrorComponent:false,
          errorMessage:'',
          potentail:0,
          updateDealState:false

        }
    }
  onError=(flag,msg)=>{
    this.setState({
      showErrorComponent:flag,
      errorMesage:msg
    })
  };
    updateState=()=>{
      this.setState({updateDealState:true,myDeals:this.props.deals});

    }
    getDeals=(deals,businessuser)=>{
      this.setState({myDeals:deals,
      user:businessuser})
    };
    setError=(show,message)=>{
      if(show)
        this.setState({showErrorComponent:show,errorMessage:message})
      else
        this.setState({showErrorComponent:false,errorMessage:''})
    };

    componentDidMount(){
      const {user}=this.props;
      this.props.GetPotential(user.results.AppUser.UserId,
        user.results.BusinessUser.Address_Lat,
        user.results.BusinessUser.Address_Long, 'deal');

      this.props.GetDeal(user.results.BusinessUser.PlaceID);
      if(this.props.deals.BusinessDeal){
        this.setState({flag:true})
      }
      this.interval = setInterval(() => {
            this.props.GetDeal(user.results.BusinessUser.PlaceID);
          }, 300000
        );
    }

    componentWillUnmount() {
      clearInterval(this.interval);
    }

    componentWillReceiveProps(nextProps){
      if(nextProps.deals.BusinessDeal){
        this.setState({dealData:nextProps.deals}
        );
      }
    }
    renderSearchResult=()=>{
     let {myDeals,user}=this.state;
      return Object.keys(myDeals).length > 0 &&
        (<Grid item sm={12} xs={12}>
        <Card content={<DealSearch deals={myDeals} user={user}/>} CardContentProps={{
          style: {minHeight: '20vh'}
        }}/>
      </Grid>)
    };
    renderAppView=()=>{
      let {myDeals,user}=this.state;
      return Object.keys(myDeals).length > 0 ?(
        <Card
          content={<DealsAppView
            deals={myDeals}
            user={user}
          />}
          CardContentProps={
            {
              style: {minHeight: '55vh'}
            }}/>)
        :
       ""

    }
    render(){
        const { user, potentialCount } = this.props;
         return(
          <div>
            {
              (this.state.showErrorComponent) && <ErrorComponent clickMethod={this.onError} msg={this.state.errorMessage}/>
            }
            <div className='container-div'>
              <ContentGrid
                header={
                    user.results.BusinessUser.IsFirstVisit && JSON.parse(user.results.BusinessUser.IsFirstVisit)['My Deals']?
                    <RouteHeader title={'My Deals'} text={`is a place where you can publish your deal. Only one
                    deal at a time is allowed, so make it a good one. Better the deal, more results you will see.`}
                    />:<span/>
                }
                content={
                  <Grid container spacing={24}>
                    <Grid item sm={12} xs={12}>
                      <section>
                        <Card content={
                          <MyDealForm
                            dealsData={this.getDeals}
                            onError={this.setError}
                            potentialData={potentialCount}
                            myDeals={this.state.deals}
                            Deal={this.state.dealData}
                            onUpdate={this.updateState}
                          />
                        } CardContentProps={{
                          style: {minHeight: '30vh'}
                        }}/>
                      </section>
                  </Grid>
                    {this.renderSearchResult()}
                  </Grid>
                }
                appView={this.renderAppView()}

            />
            </div>
          </div>
        )
    }
}
const mapStateToProps=(state)=> {
    return {
        user:state.loginResponse,
        deals:state.deals.results,
      potentialCount:state.potentialCount
    }
};
const mapDispatchToProps=(dispatch)=> {
  return bindActionCreators({
    GetDeal,
    GetPotential
  },dispatch)
};
export default connect(mapStateToProps,mapDispatchToProps)(withStyles(styles)(Deals));